import { IdKeyType } from "./main.js";
export var ShapeProperty;
(function (ShapeProperty) {
    ShapeProperty["Fill"] = "fill";
    ShapeProperty["Stroke"] = "stroke";
    ShapeProperty["StrokeWidth"] = "strokeWidth";
    ShapeProperty["PointRadius"] = "pointRadius";
})(ShapeProperty || (ShapeProperty = {}));
export var LabelProperty;
(function (LabelProperty) {
    LabelProperty["LabelText"] = "labelText";
    LabelProperty["LabelPriority"] = "labelPriority";
    LabelProperty["LabelFont"] = "labelFont";
    LabelProperty["LabelFontStyle"] = "labelFontStyle";
    LabelProperty["LabelColor"] = "labelColor";
    LabelProperty["LabelSize"] = "labelSize";
    LabelProperty["LabelWeight"] = "labelWeight";
    LabelProperty["LabelStroke"] = "labelStroke";
    LabelProperty["LabelStrokeWidth"] = "labelStrokeWidth";
})(LabelProperty || (LabelProperty = {}));
export var TemplateProperty;
(function (TemplateProperty) {
    TemplateProperty["FeatureId"] = "featureId";
})(TemplateProperty || (TemplateProperty = {}));
